// data/items/bones.js
// Bone items dropped from combat - future Ritual system

export const BONES = [
    // Tier 2 (Undead Crypt, Demon Portal)
    { id: 'small_bone', name: 'Small Bone', icon: '🦴', color: '#e8dcc8', value: 20 },
    { id: 'charred_bone', name: 'Charred Bone', icon: '🦴', color: '#4a4a4a', value: 45 },
    // Tier 3 (Dragon Lair, Void Rift, Ancient Sanctum)
    { id: 'dragon_bone', name: 'Dragon Bone', icon: '🦴', color: '#8b0000', value: 130 },
    { id: 'void_bone', name: 'Void Bone', icon: '🦴', color: '#4b0082', value: 195 },
    { id: 'elder_bone', name: 'Elder Bone', icon: '🦴', color: '#daa520', value: 275 },
];

export default BONES;
